import React from "react"

const GogoroSvg = ({ className }) => {
  return (
    <svg
      className={className}
      x="0px"
      y="0px"
      width="104px"
      height="30px"
      viewBox="0 -0.786 104 30"
      enableBackground="new 0 -0.786 104 30">
      <path
        fill="#323237"
        d="M99.979,11.917c0-1.664-0.67-3.151-1.77-4.248c-1.1-1.1-2.584-1.773-4.252-1.773
    c-1.662,0-3.15,0.675-4.248,1.773c-1.1,1.097-1.771,2.584-1.771,4.248s0.672,3.148,1.771,4.249c1.098,1.098,2.586,1.77,4.248,1.77
    c1.668,0,3.152-0.672,4.252-1.77C99.307,15.066,99.979,13.581,99.979,11.917 M102.848,11.917c0,2.443-0.992,4.673-2.586,6.269
    c-1.594,1.595-3.826,2.585-6.27,2.585c-2.445,0-4.674-0.99-6.27-2.585c-1.594-1.596-2.586-3.824-2.586-6.269
    c0-2.445,0.992-4.674,2.586-6.27c1.596-1.595,3.824-2.585,6.27-2.585c2.441,0,4.676,0.99,6.27,2.585
    C101.855,7.243,102.848,9.471,102.848,11.917 M33.505,16.166c-1.1,1.098-2.586,1.77-4.25,1.77c-1.663,0-3.152-0.672-4.25-1.77
    c-1.098-1.101-1.771-2.585-1.771-4.249s0.674-3.151,1.771-4.248c1.098-1.1,2.587-1.773,4.25-1.773c1.664,0,3.15,0.675,4.25,1.773
    c1.098,1.097,1.771,2.584,1.771,4.248C35.242,13.581,34.568,15.066,33.505,16.166 M35.525,5.648
    c-1.594-1.594-3.826-2.586-6.27-2.586c-2.444,0-4.674,0.992-6.27,2.586c-1.595,1.595-2.585,3.822-2.585,6.271
    c0,2.442,0.992,4.673,2.585,6.268c1.594,1.595,3.824,2.585,6.27,2.585c2.443,0,4.675-0.99,6.27-2.585
    c1.594-1.595,2.586-3.824,2.586-6.268C38.111,9.471,37.119,7.243,35.525,5.648 M74.443,11.917c0-1.664-0.672-3.151-1.77-4.248
    c-1.1-1.101-2.586-1.773-4.25-1.773c-1.666,0-3.152,0.675-4.252,1.773c-1.1,1.097-1.771,2.584-1.771,4.248s0.672,3.148,1.771,4.249
    c1.1,1.098,2.586,1.77,4.252,1.77c1.664,0,3.15-0.672,4.25-1.77C73.771,15.066,74.443,13.581,74.443,11.917 M77.311,11.917
    c0,2.443-0.99,4.673-2.584,6.269c-1.596,1.595-3.824,2.585-6.27,2.585c-2.441,0-4.676-0.99-6.27-2.585
    c-1.596-1.596-2.586-3.824-2.586-6.269c0-2.445,0.99-4.674,2.586-6.27c1.594-1.595,3.826-2.585,6.27-2.585
    c2.445,0,4.674,0.99,6.27,2.585C76.32,7.243,77.311,9.471,77.311,11.917 M54.822,11.917l-0.033,0.604
    c-0.143,1.417-0.781,2.69-1.736,3.646c-1.096,1.098-2.581,1.77-4.245,1.77c-1.666,0-3.154-0.672-4.252-1.77
    c-1.098-1.101-1.771-2.585-1.771-4.249s0.674-3.151,1.771-4.248c1.098-1.1,2.586-1.773,4.252-1.773c1.664,0,3.149,0.675,4.245,1.773
    C54.15,8.765,54.822,10.253,54.822,11.917L54.822,11.917z M55.105,5.648c-1.594-1.594-3.819-2.586-6.265-2.586
    c-2.441,0-4.676,0.992-6.27,2.586c-1.595,1.595-2.586,3.822-2.586,6.271c0,2.442,0.992,4.673,2.586,6.268
    c1.594,1.595,3.827,2.585,6.27,2.585c2.301,0,4.388-0.885,5.981-2.302v0.852c0,1.663-0.672,3.15-1.771,4.249
    c-1.096,1.1-2.581,1.77-4.245,1.77c-1.562,0-2.979-0.603-4.076-1.592c-0.102-0.069-0.209-0.106-0.352-0.037l-1.702,1.699
    c-0.104,0.145-0.07,0.25,0,0.356c1.594,1.522,3.752,2.442,6.092,2.442c2.443,0,4.673-0.992,6.267-2.586
    c1.596-1.595,2.586-3.824,2.586-6.27c0,0,0.037-7.151,0.037-7.401C57.691,9.471,56.699,7.243,55.105,5.648 M15.727,11.917
    c0-1.664-0.676-3.151-1.772-4.248c-1.099-1.1-2.584-1.773-4.248-1.773S6.555,6.57,5.457,7.669c-1.1,1.097-1.771,2.584-1.771,4.248
    s0.672,3.148,1.771,4.249c1.098,1.098,2.584,1.77,4.25,1.77c1.664,0,3.149-0.672,4.248-1.77c0.957-0.955,1.594-2.229,1.735-3.646
    L15.727,11.917L15.727,11.917z M18.632,11.917c0,0.246-0.037,7.401-0.037,7.401c0,2.442-0.99,4.676-2.585,6.27
    s-3.826,2.586-6.269,2.586c-2.373,0-4.535-0.922-6.094-2.445c-0.07-0.105-0.105-0.213,0-0.354l1.7-1.699
    c0.14-0.106,0.247-0.037,0.354,0.031c1.063,0.996,2.479,1.594,4.07,1.594c1.667,0,3.154-0.672,4.253-1.77
    c1.099-1.099,1.771-2.586,1.771-4.25V18.43c-1.557,1.417-3.684,2.304-5.986,2.304c-2.441,0-4.674-0.991-6.27-2.587
    c-1.698-1.557-2.689-3.787-2.689-6.229c0-2.447,0.991-4.676,2.585-6.271c1.595-1.594,3.826-2.586,6.269-2.586
    c2.445,0,4.676,0.992,6.27,2.586C17.604,7.243,18.632,9.471,18.632,11.917 M87.549,2.284c0.178-0.105,0.178-0.285,0.105-0.393
    l-1.275-1.982c-0.105-0.177-0.248-0.14-0.354-0.07c-1.877,1.168-6.518,5.17-6.518,12.078v8.145c0,0.142,0.072,0.282,0.281,0.282
    h2.303c0.215,0,0.285-0.141,0.285-0.246v-8.183C82.377,5.968,86.592,2.887,87.549,2.284"
      />
    </svg>
  )
}

export default GogoroSvg
